import axios from 'axios';

function getAuthToken(token) {
  if(token === '' || token === undefined){
    return '';
  }
  const bearerIndex = token.toLowerCase().indexOf('bearer');
  const bearerToken = bearerIndex === -1 ? 'Bearer ' + token : token;
  return bearerToken;
}

function getLocale (activeLanguage, locale) {
  if (locale) {
    return locale.replace('_', '-');
  } else if (activeLanguage) {
    return activeLanguage.replace('_', '-');
  }
  return '';
}

function makeRequest(type, currentState, api, req) {
  return new Promise(function (resolve, reject) {
    const config = {
      method: type,
      url: api,
      data: req,
      headers: {
        'Authorization': getAuthToken(currentState.authToken),
        //'Accept-Language': currentState.locale
        'Accept-Language': getLocale(currentState.activeLanguage, currentState.locale)
      }
    };
    if (type === 'get') {
      if (req !== undefined) {
        if ('download' in req)
          config.responseType = 'arraybuffer';
      } else {
        config.timeout = currentState.apiTimeOut;
      }
      Object.defineProperty(config, 'params', Object.getOwnPropertyDescriptor(config, 'data'));
      delete config['data'];
    }

    
    axios(config)
      .then(response => {
        //cacheResponse(response);
        resolve(response.data);
      })
      .catch(err => {
        if (err && err.code && err.code === 'ECONNABORTED') {
          const error = {
            'href': '',
            'error': {
              'code': 504,
              'message': 'Request timed out. Please try again.',
              'errorType': 'ECONNABORTED'
            }
          };
          reject(error);
        } else if(err.response){
          reject(err.response.data);
        }
      });
  });
}

export function get(api, currentState, req) {
  return new Promise(function (resolve, reject) {
    makeRequest('get', currentState, api, req)
      .then(response => {
        resolve(response);
      }).catch(err => {
        reject(err);
      });
  });
}

export function post(api, currentState, req) {
  return new Promise(function (resolve, reject) {
    makeRequest('post', currentState, api, req)
      .then(response => {
        resolve(response);
      }).catch(err => {
        reject(err);
      });
  });
}

export function put(api, currentState, req) {
  return new Promise(function (resolve, reject) {
    makeRequest('put', currentState, api, req)
      .then(response => {
        resolve(response);
      }).catch(err => {
        reject(err);
      });
  });
}

export function deleteRequest(api, currentState, req) {
  return new Promise(function (resolve, reject) {
    makeRequest('delete', currentState, api, req)
      .then(response => {
        resolve(response);
      }).catch(err => {
        reject(err);
      });
  });
}
